export type Brand = {
  id: string
  name: string
  /** simple-icons slug; falls back to a wordmark when unavailable */
  slug: string
  /** optional custom logo file, recoloured via CSS mask (needs transparency) */
  logoUrl?: string
  /** width / height ratio of the custom logo file */
  logoAspect?: number
  /** optical size correction — 1 = default logo height */
  logoScale?: number
  tagline: string
  hasTestDrive: boolean
  hasService: boolean
  locations: string[]
}

export const BRANDS: Brand[] = [
  {
    id: 'bmw',
    name: 'BMW',
    slug: 'bmw',
    tagline: 'Veselje do vožnje',
    hasTestDrive: true,
    hasService: true,
    locations: ['Ljubljana', 'Trzin', 'Kranj', 'Koper', 'Nova Gorica'],
  },
  {
    id: 'mini',
    name: 'MINI',
    slug: 'mini',
    logoScale: 1.45,
    tagline: 'Big Love',
    hasTestDrive: true,
    hasService: true,
    locations: ['Ljubljana'],
  },
  {
    id: 'land-rover',
    name: 'Land Rover',
    slug: 'landrover',
    logoUrl: 'https://cdn-jaguarlandrover.com/system/land-rover-new-footer.png',
    logoAspect: 3.4,
    logoScale: 0.85,
    tagline: 'Above & Beyond',
    hasTestDrive: true,
    hasService: true,
    locations: ['Ljubljana'],
  },
  {
    id: 'toyota',
    name: 'Toyota',
    slug: 'toyota',
    tagline: 'Vedno boljši avtomobili',
    hasTestDrive: true,
    hasService: true,
    locations: ['Nova Gorica'],
  },
  {
    id: 'suzuki',
    name: 'Suzuki',
    slug: 'suzuki',
    tagline: 'Way of Life!',
    hasTestDrive: true,
    hasService: true,
    locations: ['Trzin'],
  },
  {
    id: 'opel',
    name: 'Opel',
    slug: 'opel',
    tagline: 'Nemško. Po vaše.',
    hasTestDrive: true,
    hasService: true,
    locations: ['Koper', 'Trzin'],
  },
  {
    id: 'xpeng',
    name: 'XPENG',
    slug: 'xpeng',
    tagline: 'Električna prihodnost',
    hasTestDrive: true,
    hasService: false,
    locations: ['Ljubljana'],
  },
]
